var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center"},[_c('Button',{attrs:{"_key":"btnAccept","title":"Aprovar","type":"success","size":"medium","clicked":_vm.update}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }